import sl from 'element-ui/lib/locale/lang/sl';

export default {
  ...sl,

  hanshow: 'Hanshow',
  'no data': 'No data',
  'confirm': 'Confirm',
  'cancel': 'Cancel',
  'select all': 'Select all',
  hs: {
    'button': {
      'search': 'Search',
      'reset': 'Reset',
      'close': 'Close',
      'open': 'Open',
    },
  },
}